module.exports = __webpack_public_path__ + "fonts/Manrope-600-latin-ext17_1a780b6.woff2";